import Hero from '../../components/Hero';
import NavigationBar from '../../components/NavigationBar';
import Footer from '../../components/Footer';
import Partners from '../../components/Partners';
import CookieBanner from '../../components/CookieBaner';
import Boats from '../../components/Content/Boats';
import PriceTable from '../../components/Content/PriceTable';
import Gallery from '../../components/Gallery';
import { cruiseImages } from "../../components/Content/Cruises/images/cruiseImages";
import { Container } from '../../components/Content/styled';
import CruiseHero480 from "./images/katamaran.png";
import CruiseHero768 from "./images/katamaran.png";
import CruiseHero1080 from "./images/katamaran.png";
import CruiseHero1440 from "./images/katamaran.png";
import GoogleMap from '../../components/Content/GoogleMap';
import Address from '../../components/Content/Address';

function BoatsPage() {
    return (
        <>
            <NavigationBar variant="boats" />
            <main>
                <Hero variant="boats" images={{
                    480: CruiseHero480,
                    768: CruiseHero768,
                    1080: CruiseHero1080,
                    1440: CruiseHero1440,
                }} />
                <Container>
                    <Boats />
                    <PriceTable variant="boats" />
                    <Address variant="boats" />
                    <GoogleMap variant="boats" />
                </Container>
                <Gallery images={cruiseImages} variant="boats" />
                <Partners />
            </main>
            <Footer />
            <CookieBanner />
        </>
    );
}
export default BoatsPage;